/*global sentry_release*/
import { LicenseManager } from "ag-grid-enterprise";
import mixpanel from "mixpanel-browser";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import * as Sentry from "@sentry/react";

import { message } from "./utils/message";
import { widgetAuth } from "./utils/widgetAuth";
import App from "./App";

LicenseManager.setLicenseKey(
  "CompanyName=intelligems.io,LicensedApplication=Intelligems Web UI,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-029469,SupportServicesEnd=18_June_2023_[v2]_MTY4NzA0MjgwMDAwMA==85f2438c3463825e18a93ccb00e10910"
);

// enableAllPlugins();

const prodHost = "app.intelligems.io";
const devHost = "app-dev.intelligems.io";
const devToken = "eacc2d71bd5d818fed4768c641aeb284";
const prodToken = "aaf6d392bdbfdc48717cb30ff41f15b7";

if (window.location.hostname === prodHost) {
  mixpanel.init(prodToken);
} else if (window.location.hostname === devHost) {
  mixpanel.init(devToken, { debug: true });
} else {
  mixpanel.init(devToken, { debug: true });
  // mixpanel.disable();
}

export const REACT_QUERY_CACHE = "REACT_QUERY_OFFLINE_CACHE";

console.log("local", import.meta.env.RUNNING_LOCAL);
Sentry.init({
  dsn: "https://8dcec2a66c3c4f628890446960e3948b@o940103.ingest.sentry.io/6165768",
  // @ts-ignore
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
    new Sentry.Replay(),
  ],
  environment: import.meta.env.VITE_STAGE,
  tracesSampleRate: 1.0,
  maxBreadcrumbs: 50,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
    "The operation is insecure.",
    "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document.",
    "Non-Error promise rejection captured",
    "Cannot read properties of undefined (reading 'content')",
    "Request aborted",
    "Failed to get Hubspot Token",
    "Cannot read properties of null (reading 'style')",
  ], //Add any errors you want to ignore here
  normalizeDepth: 10, // how deep of redux state to push
  enabled: !process.env.RUNNING_LOCAL,
});

const _root = <App />;

const container = document.getElementById("root");

if (window.parent === window) {
  window.addEventListener(
    "beforeunload",
    () => {
      console.log("beforeunload");
      message({ type: "CLOSED" }, "*");
    },
    { capture: true }
  );
  const root = createRoot(container!);
  root.render(_root);
} else {
  // inside an iframe
  widgetAuth();
}
